export const APP_ROOT_ENDPOINT = process.env.REACT_APP_ROOT_API;
export const MAPBOX_ROOT_URL = 'mapbox://styles/mapbox/';
export const MAPBOX_GEOCODE_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

export const States = Object.freeze({

  VIC: 'VIC',
  ACT: 'ACT',
  TAS: 'TAS',
  NSW: 'NSW',
  NT : 'NT',
  QLD: 'QLD',
  WA: 'WA',
  SA: 'SA'

});

export const appActions = Object.freeze({

  GET_APPLICATION_LINKS: 'GET_APPLICATION_LINKS',

  APP_LOADING: 'APP_LOADING',

  USER_AUTH_SUCCESS: 'USER_AUTH_SUCCESS',
  USER_AUTH_FAIL: 'USER_AUTH_FAIL',

  USER_REAUTH_SUCCESS: 'USER_REAUTH_SUCCESS',
  USER_REAUTH_FAIL: 'USER_REAUTH_FAIL',

  NEW_USER_SUCCESS: 'NEW_USER_SUCCESS',
  NEW_USER_FAIL: 'NEW_USER_FAIL',

  EDIT_USER_ACCOUNT_SUCCESS: 'EDIT_USER_ACCOUNT_SUCCESS',
  EDIT_USER_ACCOUNT_FAIL: 'EDIT_USER_ACCOUNT_FAIL',

  CREATE_SEPARATE_ACCOUNT_SUCCESS: 'CREATE_SEPARATE_ACCOUNT_SUCCESS',
  CREATE_SEPARATE_ACCOUNT_FAIL: 'CREATE_SEPARATE_ACCOUNT_FAIL',

  DELETE_ACCOUNT_SUCCESS: 'DELETE_ACCOUNT_SUCCESS',
  DELETE_ACCOUNT_FAIL: 'DELETE_ACCOUNT_FAIL',

  USER_LOG_OUT: 'USER_LOG_OUT'

});

export const mainviewActions = Object.freeze({

  GEOLOCATE_USER_SUCCESS: 'GEOLOCATE_USER_SUCCESS',
  GEOLOCATE_USER_ERROR: 'GEOLOCATE_USER_ERROR',

  RESET_MAP_VIEW: 'RESET_MAP_VIEW',

  SEARCH_ADDRESS_SELECTED: 'SEARCH_ADDRESS_SELECTED',

  HIDE_SEARCH_MARKER: 'HIDE_SEARCH_MARKER',

  SET_MAP_LAYER_TYPE: 'SET_MAP_LAYER_TYPE',

  GET_USER_ACCOUNTS: 'GET_USER_ACCOUNTS',
  REMOVE_USER_ACCOUNT_LIST: 'REMOVE_USER_ACCOUNT_LIST',

  EDIT_USER_ACCOUNT: 'EDIT_USER_ACCOUNT',
  EDIT_USER_ACCOUNT_CANCEL: 'EDIT_USER_ACCOUNT_CANCEL',

  EDIT_KOALA_SIGHTING: 'EDIT_KOALA_SIGHTING',
  EDIT_KOALA_SIGHTING_SUCCESS: 'EDIT_KOALA_SIGHTING_SUCCESS',
  EDIT_KOALA_SIGHTING_CANCEL: 'EDIT_KOALA_SIGHTING_CANCEL',

  ADD_SIGHTING_SUCCESS: 'ADD_SIGHTING_SUCCESS',

  GET_KOALA_SIGHTINGS_BY_USER: 'GET_KOALA_SIGHTINGS_BY_USER',
  GET_ALL_KOALA_SIGHTINGS: 'GET_KOALA_SIGHTINGS',

  SHOW_KOALA_GEOJSON: 'SHOW_KOALA_GEOJSON',
  HIDE_KOALA_GEOJSON: 'HIDE_KOALA_GEOJSON',

  SHOW_FEDERAL_GEOJSON: 'SHOW_FEDERAL_GEOJSON',
  HIDE_FEDERAL_GEOJSON: 'HIDE_FEDERAL_GEOJSON',

  SHOW_LGA_GEOJSON: 'SHOW_LGA_GEOJSON',
  HIDE_LGA_GEOJSON: 'HIDE_LGA_GEOJSON',

  SHOW_PROPERTY_LAYER: 'SHOW_PROPERTY_LAYER',
  HIDE_PROPERTY_LAYER: 'HIDE_PROPERTY_LAYER',

  SHOW_STATE_GEOJSON: 'SHOW_STATE_GEOJSON',
  HIDE_STATE_GEOJSON: 'HIDE_STATE_GEOJSON',

  SHOW_NVIS_LAYER: 'SHOW_NVIS_LAYER',
  HIDE_NVIS_LAYER: 'HIDE_NVIS_LAYER',

  SHOW_KHA_LAYER: 'SHOW_KHA_LAYER',
  HIDE_KHA_LAYER: 'HIDE_KHA_LAYER',

  SHOW_PRECLEARING_LAYER: 'SHOW_PRECLEARING_LAYER',
  HIDE_PRECLEARING_LAYER: 'HIDE_PRECLEARING_LAYER',

  SHOW_KOALA_POPUP: 'SHOW_KOALA_POPUP',
  HIDE_KOALA_POPUP: 'HIDE_KOALA_POPUP',

  SHOW_BOUNDARY_POPUP: 'SHOW_BOUNDARY_POPUP',
  HIDE_BOUNDARY_POPUP: 'HIDE_BOUNDARY_POPUP',

  GET_FEDERAL_BOUNDARY_DATA: 'GET_FEDERAL_BOUNDARY_DATA',
  REMOVE_FEDERAL_BOUNDARY_DATA: 'REMOVE_FEDERAL_BOUNDARY_DATA',

  GET_STATE_BOUNDARY_DATA: 'GET_STATE_BOUNDARY_DATA',
  REMOVE_STATE_BOUNDARY_DATA: 'REMOVE_STATE_BOUNDARY_DATA',

  GET_LGA_BOUNDARY_DATA: 'GET_LGA_BOUNDARY_DATA',
  REMOVE_LGA_BOUNDARY_DATA: 'REMOVE_LGA_BOUNDARY_DATA',

  SELECT_LOCATION_ON_MAP: 'SELECT_LOCATION_ON_MAP',
  SELECT_LOCATION_ON_MAP_COMPLETE: 'SELECT_LOCATION_ON_MAP_COMPLETE',
  SELECT_LOCATION_ON_MAP_CANCEL: 'SELECT_LOCATION_ON_MAP_CANCEL'
  
});

export const sidebarActions = Object.freeze({

  CHANGE_SIDEBAR_ITEM: 'CHANGE_SIDEBAR_ITEM',
  CLOSE_SUBNAV: 'CLOSE_SUBNAV'

});

export const modalActions = Object.freeze({

  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',

  SUSPEND_MODAL: 'SUSPEND_MODAL',

  SET_DEFAULT_AUTHENTICATION_FORM: 'SET_DEFAULT_AUTHENTICATION_FORM'

});